module.exports = __webpack_public_path__ + "static/img/10.c3241ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/10.png
// module id = FRoM
// module chunks = 0